import { create, remove, update, createFile } from "@/service/apis/Base";
import { FilePostRequest } from "@/utility/api";
import { Ref, ref } from "@vue/composition-api";

export function uploadFile(
  newItem: FormData,
  path: string,
  backendUpdatedURL: Ref<string>
) {
  createFile(
    newItem,
    backendUpdatedURL,
    { folderPath: path },
    "File",
    undefined,
    FilePostRequest
  );
}
